import React from "react";

function NCXFormDivider(props) {
    return (
        <div 
            style={{ 
                width: props?.field?.properties?.orientation === "vertical" ? props?.field?.properties?.lineSize : '100%',
                height: props?.field?.properties?.orientation === "vertical" ? '100%' : props?.field?.properties?.lineSize,
                backgroundColor: props?.field?.properties?.lineColor,
                margin: props?.field?.properties?.orientation === "vertical" ? '0 16px' : '16px 0',
                borderRadius: '4px'
            }}
        />
    )
}

export default NCXFormDivider;